import React from 'react';

export const SelectIcon = (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinejoin="round" aria-hidden="true" {...props}>
        <path d="M5 3l6 17 2.4-6.6L20 11z"/>
    </svg>
);

export const OvalIcon = (props) => (
    <svg width="20" height="18" viewBox="0 0 24 20" fill="none" stroke="currentColor" strokeWidth="2"
         aria-hidden="true" {...props}>
        <ellipse cx="12" cy="10" rx="9.5" ry="6.5"/>
    </svg>
);

export const NoteIcon = (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinejoin="round" aria-hidden="true" {...props}>
        <path d="M4 4h16v10l-6 6H4z"/>
        <path d="M14 20v-6h6"/>
    </svg>
);

export const FitScreenIcon = (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
        <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>
    </svg>
);

export const ChevronDownIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
        <path d="M6 9l6 6 6-6"/>
    </svg>
);

export const ReplaceIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
        <rect x="3" y="4" width="18" height="16" rx="2"/>
        <circle cx="9" cy="10" r="2"/>
        <path d="M21 16l-5-5-9 9"/>
    </svg>
);

export const SyncIcon = (props) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8"
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
        <path d="M2 8a7 7 0 0 1 12-4l2 2M16 2v4h-4M16 10a7 7 0 0 1-12 4l-2-2M2 16v-4h4"/>
    </svg>
);

export const TrashIcon = (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
        <path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/>
    </svg>
);
